<template>
  <div>
    <el-form size="mini" ref="form" label-position="left" label-width="130px" v-loading="loading" element-loading-spinner="nucleus-loader">
      <el-row :gutter="30">
        <el-col :span="12">
          <h4 class="headerWithBorder">Chart Demographic</h4>

          <el-form-item size="mini" label="Patient Number">
            <a v-if="documentManagerAdmin()" style="margin: 6px 0px 0px 0px; float: left;" :href="`${compParticleBaseUrl}/reviews/outpatient/${$route.params.ascTableId}`" target="_new">{{ worksheet.patAcctNum }}</a>
            <el-input v-else disabled size="mini" :maxlength="15" type="text" id="patientNumber" v-model="worksheet.patAcctNum"> </el-input>
          </el-form-item>

          <!-- <el-form-item size="mini" label="Patient Number">
            <el-input disabled size="mini" :maxlength="15" type="text" id="patientNumber" v-model="worksheet.patAcctNum"> </el-input>
          </el-form-item> -->

          <el-form-item size="mini" label="MR Number">
            <el-input :disabled="disabled" size="mini" :maxlength="15" type="text" id="mrNumber" v-model="worksheet.mrNumber"> </el-input>
          </el-form-item>

          <el-form-item size="mini" label="Chart Type">
            <el-input :disabled="disabled" v-model="worksheet.patientTypeDescription"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="Payor">
            <el-input :disabled="disabled" v-model="worksheet.payorName" placeholder="Payor" itemkey="key" label="value"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="Payor Detail">
            <el-input :disabled="disabled" v-model="worksheet.payorDetail" placeholder="Payor Detail" itemkey="key" label="value"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="Date of Service">
            <el-date-picker style="width: 100%;" :disabled="disabled" size="mini" type="date" id="dischargeDate" v-model="worksheet.dateOfService" format="MM/dd/yyyy"> </el-date-picker>
          </el-form-item>

          <el-form-item size="mini" label="Age">
            <el-input disabled v-model="worksheet.patientAge"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="Patient Sex">
            <el-input disabled v-model="worksheet.sex"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="UB Available">
            <el-input disabled :value="!worksheet.noUBAvailable ? `Yes` : `No`"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <h4 class="headerWithBorder">Review Information</h4>

          <el-form-item size="mini" label="Facility">
            <el-input disabled v-model="worksheet.clientName"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="Auditor">
            <el-input disabled v-model="worksheet.reviewerName"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="Review Date">
            <el-date-picker style="width: 100%;" disabled size="mini" type="date" id="revDate" v-model="worksheet.reviewDate" format="MM/dd/yyyy"> </el-date-picker>
          </el-form-item>

          <el-form-item size="mini" label="Coder Query">
            <el-input disabled :value="worksheet.coderQuery ? `Yes` : `No`"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="HIA Query">
            <el-input disabled :value="worksheet.hiaQuery ? `Yes` : `No`"></el-input>
          </el-form-item>

          <el-form-item v-if="worksheet.outpatientGrouperId === 1" size="mini" label="APC Change">
            <el-input disabled :value="worksheet.numberAPCChanges > 0 ? `Yes` : `No`"></el-input>
          </el-form-item>

          <el-form-item v-else size="mini" label="Financial Impact">
            <el-input disabled v-model="worksheet.ascFinancialImpact"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="Provider">
            <el-input disabled v-model="worksheet.physician"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="Coder">
            <el-row>
              <el-col style="font-size:12px;" :span="10"> Code Type </el-col>

              <el-col style="font-size:12px;" :span="14"> Coder </el-col>
            </el-row>
            <el-row v-for="coder in worksheet.coders" :key="coder.id">
              <el-col :span="10">
                <el-input :title="coder.codeTypeDescription" disabled v-model="coder.codeTypeDescription"></el-input>
              </el-col>
              <el-col :span="14">
                <el-input :title="coder.coderName" disabled v-model="coder.coderName"></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <!-- <el-form-item size="mini" label="Audit Result">
            <el-input disabled v-model="worksheet.auditResult"></el-input>
          </el-form-item> -->
        </el-col>
      </el-row>

      <!-- <el-row :gutter="20">
        <el-col :xl="8" :sm="12" class="top-margin">
          <h4 class="headerWithBorder">Original Coding Details</h4>

          <el-form-item size="mini" label="Patient Status">
            <el-input disabled v-model="worksheet.originalPatientStatus"></el-input>
          </el-form-item>
        </el-col>
      </el-row> -->
    </el-form>
  </div>
</template>

<script>
import dateHelper from '@/mixins/date-helper'
import { format, parseISO } from 'date-fns'
import { mapMutations } from 'vuex'
import HiaAuthorization from '@/mixins/hiaAuthorization'

export default {
  name: 'coderOutpatientDemographics',
  mixins: [dateHelper, HiaAuthorization],
  props: ['worksheet'],
  data() {
    return {
      format: format,
      parseISO: parseISO,
      disabled: true,
      loading: false
    }
  },
  methods: {
    ...mapMutations('myProjects/', ['SET_RESPONSE_PATSTAT', 'SET_RESPONSE_DRG', 'SET_RESPONSE_POO'])
  },
  computed: {
    compParticleBaseUrl() {
      return process.env.VUE_APP_PARTICLE_BASE_URL
    }
    // ...mapState('profile/', ['userProfile'])
  }
}
</script>
